import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import React from 'react';

import Exportpdf from '@/modules/workingDay/components/Details/Header/Exportpdf';
import { IWorkingDay } from '@/modules/workingDay/types';
import { Typography } from '@/shared/components/atoms';
import { JobInstanceCard } from '@/shared/components/molecules';
import { JOB_INSTANCES } from '@/shared/constant/backendStatus';

interface Props {
  instance: IWorkingDay.IJobInstance | undefined;
  showExportPdf?: boolean;
  suppliers: IWorkingDay.IJobInstanceSupplier[];
}

const Header: React.FC<Props> = ({
  instance,
  showExportPdf = true,
  suppliers,
}) => {
  const { t } = useTranslation('common');
  const { query } = useRouter();

  const statusBgColor = instance
    ? JOB_INSTANCES[instance?.jobInstanceStatus].color
    : '';
  const statusTextColor = instance
    ? JOB_INSTANCES[instance?.jobInstanceStatus].textColor
    : '';

  return (
    <section>
      <div className='mb-7 flex items-center justify-between'>
        <div className='flex items-center gap-24'>
          <Typography variant='h2' weight='bold'>
            {t('job-order')} {query?.id || ''}
          </Typography>
          <span
            className='rounded-lg px-24 py-1 '
            style={{
              backgroundColor: statusBgColor,
              color: statusTextColor,
            }}
          >
            <Typography variant='caption' weight='bold'>
              {instance && t(JOB_INSTANCES[instance.jobInstanceStatus].label)}
            </Typography>
          </span>
        </div>
        {showExportPdf && (
          <Exportpdf instance={instance} suppliers={suppliers} />
        )}
        {/* eslint-disable-next-line @typescript-eslint/no-empty-function */}
        {/* <Button onClick={() => {}} size='md' className='mt-auto'>
            {instance &&
            JOB_INSTANCES[instance.jobInstanceStatus].label === 'ended'
              ? t('agree')
              : t('finish')}
          </Button> */}
      </div>
      <JobInstanceCard
        jobInstance={instance}
        showArrow={false}
        showStatus={false}
        showJobId={false}
      />
    </section>
  );
};
export default Header;
